import { MakeCall } from './createMakeCall';

export interface ListingVideoUploadRecord {
  url: string;
  contentType: string;
  expires: string;
  videoId: number;
  videoUuid: string;
}

const requestListingVideoUpload = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingVideoUploadRecord>(
    'POST',
    `/api/v2/listing/${listingId}/videos/request`,
  );
export { requestListingVideoUpload };
